import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import useDatabase from '../../hooks/useDatabase';
import './FeaturedSandwich.css';

const FeaturedSandwich = () => {
  const { isLoading, getAllSpecialtySandwiches } = useDatabase();

  if (isLoading) return null;

  const sandwiches = getAllSpecialtySandwiches();
  const featured = sandwiches.find((s) => s.featured) || sandwiches[0];
  if (!featured) return null;

  return (
    <section className="featured-sandwich">
      <div className="container">
        <div className="featured-badge">
          <span className="star-icon">
            <FontAwesomeIcon icon={faStar} />
          </span>
          <span>Featured Special</span>
        </div>
        <div className="featured-content">
          <div className="featured-details">
            <h2 className="force-revue">{featured.name}</h2>
            <p className="featured-description">{featured.description}</p>
            <div className="featured-meta">
              <div className="featured-price">{featured.price}</div>
              <a href="tel:248-352-7377" className="btn primary">
                <FontAwesomeIcon icon={faPhoneAlt} /> Order Now
              </a>
            </div>
          </div>
          <div className="featured-image-container">
            <div className="featured-image"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSandwich;
